import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/login/page";
import Order from "../pages/order/page";
import AdminLogin from "../pages/admin/login/page";
import AdminOrders from "../pages/admin/orders/page";
import AdminOrderDetail from "../pages/admin/orders/detail/page";
import AdminStyles from "../pages/admin/styles/page";
import AdminPortfolios from "../pages/admin/portfolios/page";
import AdminRoute from "../components/AdminRoute";
import ProtectedRoute from "../components/ProtectedRoute";
import MyOrders from "../pages/my-orders/page";
import PaymentSuccess from "../pages/payment/success";
import PaymentFail from "../pages/payment/fail";
import ForgotPassword from "../pages/login/forgot-password";
import Trial from "../pages/trial/page";
import Terms from "../pages/legal/terms";
import Privacy from "../pages/legal/privacy";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/order",
    element: (
      <ProtectedRoute>
        <Order />
      </ProtectedRoute>
    ),
  },
  {
    path: "/my-orders",
    element: (
      <ProtectedRoute>
        <MyOrders />
      </ProtectedRoute>
    ),
  },
  {
    path: "/payment/success",
    element: (
      <ProtectedRoute>
        <PaymentSuccess />
      </ProtectedRoute>
    ),
  },
  {
    path: "/payment/fail",
    element: <PaymentFail />,
  },
  {
    path: "/trial",
    element: <Trial />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin/orders",
    element: (
      <AdminRoute>
        <AdminOrders />
      </AdminRoute>
    ),
  },
  {
    path: "/admin/orders/:id",
    element: (
      <AdminRoute>
        <AdminOrderDetail />
      </AdminRoute>
    ),
  },
  {
    path: "/admin/styles",
    element: (
      <AdminRoute>
        <AdminStyles />
      </AdminRoute>
    ),
  },
  {
    path: "/admin/portfolios",
    element: (
      <AdminRoute>
        <AdminPortfolios />
      </AdminRoute>
    ),
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
